module.exports = __webpack_public_path__ + "static/media/Close01.74bd27f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svgs/SocialMediaMenu/Close01.svg
// module id = 327
// module chunks = 0